
//@ts-ignore
export const API_HOST = window['API_HOST'] || process.env.REACT_APP_API;
